import { AccountController } from "@/app/ui/controllers/AccountController";

const getWatermark = () => {
  const text = AccountController.accountData.watermark || "";

  const svg = `
  <svg xmlns='http://www.w3.org/2000/svg' width='500' height='250'>
    <text x="50%" y="50%"
      text-anchor="middle"
      dominant-baseline="middle"
      transform="rotate(-20 250 200)"
      fill="black"
      fill-opacity="0.07"
      font-size="24"
      font-weight="600"
      letter-spacing="2"
      font-family="Montserrat, sans-serif"
    >
      ${text.substring(0, 20)}
    </text>
  </svg>
`;

  const encoded = encodeURIComponent(svg)
    .replace(/'/g, "%27")
    .replace(/"/g, "%22");

  return {
    backgroundImage: `url("data:image/svg+xml;utf8,${encoded}")`
  };
}

export default getWatermark;
